import React from "react"

import id from "@irati/utils/id"
import UploadImage from "./UploadImage"

const ThumbnailImage = (props) => (
  <UploadImage
    {...props}
    id={id("thumbnailImage", props)}
    property="thumbnailImage"
    label="Upload thumbnail image:"
    dimensions={{
      width: 165,
      height: 165
    }} />
)

ThumbnailImage.defaultProps = {
  id: "rewardThumbnailImage"
}

export default ThumbnailImage
